import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  templateUrl: './simple-modal.component.html',
  standalone: false,
})
export class SimpleModalComponent {
  @Input() text = 'Are you sure?';
  @Input() title = 'Confirmation';
  @Input() okButtonLabel?: string;
  @Input() cancelButtonLabel?: string;
  @Input() showCancelButton = true;

  constructor(public activeModal: NgbActiveModal) {}
}
